module.exports = __webpack_public_path__ + "static/media/data2.8095bd77.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/data2.csv
// module id = 522
// module chunks = 0